import {
  Pressable,
  ScrollView as GSScrollView,
  View,
  Text,
  VStack,
  Spinner
} from "@gluestack-ui/themed";
import { SectionTitle } from "@repo/core/components/layout/SectionTitle";
import { formatDateWithCurrentDay } from "@repo/core/utils/date.utils";
import { ProposalCard } from "@repo/core/components/layout/ProposalCard";
import { Icon } from "@repo/core/components/core/Icon";
import { styles } from "@repo/core/screens/Home/styles";
import { useRecentProposalsController } from "@repo/core/screens/Home/sections/RecentProposals/controller";

export const RecentProposals = () => {
  const {
    isResponsive,
    goLeft,
    goRight,
    setCurrentPosition,
    refScroll,
    handleGoToAllProposals,
    showCarrousel,
    recentProposals,
    isFetching
  } = useRecentProposalsController();
  const shouldShowNavigation =
    showCarrousel && !isResponsive && recentProposals.length > 0;

  return (
    <>
      <SectionTitle
        title="Propostas Recentes"
        onShowAll={handleGoToAllProposals}
      />

      <VStack py="$4" mb="$4">
        <Text color="$textLight600" fontSize="$sm">
          {formatDateWithCurrentDay(new Date(Date.now()))}
        </Text>
        <View flex={1} position="relative">
          {shouldShowNavigation ? (
            <Pressable
              bg="$white"
              borderRadius="$full"
              p="$2"
              top="35%"
              shadowColor="$textLight200"
              shadowOffset={styles.shadowIcons}
              left={0}
              position="absolute"
              zIndex={500}
              onPress={goLeft}
            >
              <Icon name="chevron-left" color="#000000" size={22} />
            </Pressable>
          ) : null}
          {isFetching ? (
            <View alignItems="center" justifyContent="center" py="$8">
              <Spinner size="large" />
            </View>
          ) : recentProposals.length === 0 ? (
            <View alignItems="center" justifyContent="center" py="$8">
              <Text color="$textLight600" fontSize="$sm">
                Nenhuma proposta encontrada para hoje
              </Text>
            </View>
          ) : (
            <GSScrollView
              ref={(ref) => {
                // @ts-ignore: Object is possibly 'null'.
                refScroll.current = ref?.getScrollResponder() || null;
              }}
              onScroll={(event) =>
                setCurrentPosition(event.nativeEvent.contentOffset.x)
              }
              horizontal
              showsHorizontalScrollIndicator={false}
              mt="$4"
              pb={!showCarrousel || isResponsive ? null : "$4"}
              mx={!showCarrousel || isResponsive ? null : "$4"}
              gap="$2"
            >
              {recentProposals.map((proposal) => (
                <ProposalCard
                  key={proposal.proposalId}
                  cardName={proposal.cardName}
                  proposalId={proposal.proposalId}
                  status={proposal.status}
                  statusCode={proposal.statusCode}
                  statusDescription={proposal.statusDescription}
                  type={proposal.type}
                  name={proposal.name}
                />
              ))}
            </GSScrollView>
          )}
          {shouldShowNavigation ? (
            <Pressable
              bg="$white"
              borderRadius="$full"
              p="$2"
              top="35%"
              shadowColor="$textLight200"
              shadowOffset={styles.shadowIcons}
              position="absolute"
              right={-5}
              zIndex={500}
              onPress={goRight}
            >
              <Icon name="chevron-right" color="#000000" size={22} />
            </Pressable>
          ) : null}
        </View>
      </VStack>
    </>
  );
};
